import { NationalNumberingPlan } from 'src/core/models/phone-number/national-numbering-plan.model';

/**
 * The national numbering plans the platform has rules for, one per country code — the ONLY copy of
 * this table in the frontend.
 *
 * Mirrors backend `CountryCallingCodes.NationalNumberingPlans`
 * (`Domain.Shared/Helpers/CountryCallingCodes.cs`) entry for entry; change both together. An entry
 * may cover only the common national number length the platform accepts (the United Kingdom and
 * Germany: 10 digits); numbers outside it are neither completed nor rewritten to the national form.
 */
export const NATIONAL_NUMBERING_PLANS: readonly NationalNumberingPlan[] = [
  // Turkey: trunk prefix 0 + 10-digit NSN (0 212 123 45 67).
  { countryCode: '90', trunkPrefix: '0', nationalNumberMinLength: 10, nationalNumberMaxLength: 10 },

  // United Kingdom: trunk prefix 0 + 10-digit NSN.
  { countryCode: '44', trunkPrefix: '0', nationalNumberMinLength: 10, nationalNumberMaxLength: 10 },

  // Germany: trunk prefix 0 + 10-digit NSN.
  { countryCode: '49', trunkPrefix: '0', nationalNumberMinLength: 10, nationalNumberMaxLength: 10 },

  // North American Numbering Plan (US, Canada and the other +1 members): trunk prefix 1 + 10-digit
  // NSN (1 415 555 0123). The trunk is "1", not "0", so it never joins the "(0)"-after-country-code
  // stripping.
  { countryCode: '1', trunkPrefix: '1', nationalNumberMinLength: 10, nationalNumberMaxLength: 10 },
];
